import React, { useContext, useState } from 'react';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import { ShowCabinetContext } from './types';
import { useDispatch } from 'react-redux';
import { DeleteCabinetApi } from '../../redux/cabinets/cabinetApiCalls';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';
import { Timeout } from '../../functions/functions';

interface props {
  modal: boolean,
  toggle: any
}

const DeleteCabinet:React.FC<props> = ({ modal, toggle }) => {
  const { selectedCabinet, setShowSuccessMsg } = useContext(ShowCabinetContext)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<string[]>([])

  const dispatch: any = useDispatch()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      setLoading(true)
      const response = await dispatch(DeleteCabinetApi(selectedCabinet._id))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm loading={loading} typeBtn='Supprimer' toggle={toggle}/>
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DeleteCabinet
